module.exports = __webpack_public_path__ + "img/security4.d384413c.png";